import React, { useCallback, useEffect } from "react";
import { MdRefresh } from "react-icons/md";
import { connect } from "react-redux";
import { Alert, Spinner } from "reactstrap";

import { Field } from "redux-form";

import renderSelectField from "../../../../shared/components/form/Select";
import { getAuditBy } from "../../actions/getAuditBy.actions";

const AuditByDropdown = ({
  label,
  disabled,
  onChange,
  id,
  required,
  dispatch,
  auditBy,
}) => {
  const handleGetAuditBy = useCallback(() => {
    dispatch(getAuditBy());
  }, [dispatch]);

  useEffect(() => {
    handleGetAuditBy();
  }, [handleGetAuditBy]);

  return (
    <div className="form__form-group">
      <span className={`form__form-group-label ${required ? "required" : ""}`}>
        {label}
      </span>
      <div className="form__form-group-field">
        <Field
          id={id}
          name="groupId"
          customChange={onChange}
          component={renderSelectField}
          options={(auditBy.response && auditBy.response.data) || []}
          valueKey="id"
          disabled={disabled}
          labelKey="name"
          placeholder="All"
        />
      </div>
      {auditBy && auditBy.error ? (
        <Alert color="danger">
          Could not fetch activty log actions
          {auditBy.loading ? (
            <Spinner className="float-right" size="sm" color="danger" />
          ) : (
            <MdRefresh
              onClick={handleGetAuditBy}
              className="float-right pointer"
              size={20}
            />
          )}
        </Alert>
      ) : null}
    </div>
  );
};

export default connect((state) => ({
  auditBy: state.auditBy,
}))(AuditByDropdown);
